import React from 'react';
import Styled from 'styled-components';
import {Button, EMPHASIS, Frame, Text} from '@forecast-it/design-system';
import {HiddenLabel} from '../HiddenLabel';

/**
 * The pieces the time and expense estimate editors share, so the two keep the same look and the same
 * accessible names.
 */

/** Wraps a NumberField, which forwards no aria props, so the field takes its name from a HiddenLabel inside. */
export const FieldLabel = Styled.label`
	position: relative;
	display: block;
`;

/** The bordered, centred message shown when a phase has no lines of this kind, as on the Baseline page. */
export const EmptyEstimates = ({message}: {message: string}): JSX.Element => (
	<Frame centerContent>
		<Text color="auxiliary">{message}</Text>
	</Frame>
);

type RemoveRowButtonProps = {labelId: string; label: string; 'data-cy': string; onPress: () => void};

/** The row's ×. The design-system Button overwrites aria-label, so it is named through aria-labelledby. */
export const RemoveRowButton = ({labelId, label, 'data-cy': dataCy, onPress}: RemoveRowButtonProps): JSX.Element => (
	<div>
		<HiddenLabel id={labelId}>{label}</HiddenLabel>
		<Button emphasis={EMPHASIS.LOW} icon="close" aria-labelledby={labelId} data-cy={dataCy} onPress={onPress} />
	</div>
);

type AddRowButtonProps = {label: string; 'data-cy': string; onPress: () => void};

export const AddRowButton = ({label, 'data-cy': dataCy, onPress}: AddRowButtonProps): JSX.Element => (
	<div>
		<Button emphasis={EMPHASIS.LOW} icon="plus" data-cy={dataCy} onPress={onPress}>
			{label}
		</Button>
	</div>
);
